import { type OwaDate, today } from 'owa-datetime';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from 'owa-viewstate-store';
import { createStore } from 'owa-satcheljs';
import { DateRangeType } from '@fluentui/date-time-utilities';
import { getDefaultWeekRange } from '../utils/getDefaultWeekRange';
import type { DateRange } from 'owa-datetime-utils';

export interface HybridspaceWeekPickerStore {
    currentDate: OwaDate;
    currentDateRange: DateRange;
    currentDateRangeType: DateRangeType;
}

const getStore: () => HybridspaceWeekPickerStore = createStore('hybridspace-week-picker', {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function today called at module scope is not allowed. This may cause unwanted side effects. */
    currentDate: today(),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getDefaultWeekRange called at module scope is not allowed. This may cause unwanted side effects. */
    currentDateRange: getDefaultWeekRange(),
    currentDateRangeType: DateRangeType.Week,
});
const dest = createAccessors('hybridspace-week-picker', getStore);
const setCurrentDate: (newValue: OwaDate) => void = dest.setCurrentDate;
const getCurrentDate: () => OwaDate = dest.getCurrentDate;
const setCurrentDateRange: (newValue: DateRange) => void = dest.setCurrentDateRange;
const getCurrentDateRange: () => DateRange = dest.getCurrentDateRange;
const setCurrentDateRangeType: (newValue: DateRangeType) => void = dest.setCurrentDateRangeType;
const getCurrentDateRangeType: () => DateRangeType = dest.getCurrentDateRangeType;

export {
    getStore,
    setCurrentDate,
    getCurrentDate,
    setCurrentDateRange,
    getCurrentDateRange,
    setCurrentDateRangeType,
    getCurrentDateRangeType,
};
